import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import { CustomText } from "../components";

interface ICustomPopup extends ModalContentProps {
  children: any;
  open: boolean;
  onClose: () => void | null;
  showCloseHeader?: boolean;
  title?: string;
  width?: string;
  bodyPadding?: string;
}
function CustomPopup(props: ICustomPopup) {
  const {
    children,
    open = false,
    onClose = () => null,
    showCloseHeader = true,
    title = "Title",
    width = "600px",
    style = {},
    bodyPadding,
    ...restProps
  } = props;
  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        m={"auto"}
        minWidth={{ base: "100%", sm: width }}
        {...restProps}
        bgColor={"theme.gray.lightGray700"}
        maxH={"100vh"}
        overflowY={"auto"}
        className="hide-scrollbar"
        style={style}
      >
        {showCloseHeader && (
          <ModalHeader minH={"60px"} maxH={"60px"}>
            <CustomText fontSize={"20px"} fontWeight={500} text={title} />
            <ModalCloseButton mt={"6px"} />
          </ModalHeader>
        )}
        <ModalBody style={{ ...(bodyPadding ? { padding: bodyPadding } : {}) }}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export { CustomPopup };
